import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
const tomes = [{
  badge: 'TOMO 01',
  title: '📖 El Lenguaje Secreto del Cuerpo',
  subtitle: 'Fundamentos que nadie te enseñó',
  description: 'Las reglas del juego no verbal que el 95% ignora. Aprendés a mapear el cuerpo completo, establecer el baseline y detectar las 7 emociones universales en tiempo real. Incluye 7 capítulos con ejercicios prácticos.',
  bullets: ['El mapa completo del cuerpo humano', 'Cómo sacar el baseline en 3 minutos', 'Las 7 emociones universales y cómo leerlas', 'Proxémica: el lenguaje del espacio', '7 ejercicios aplicables desde hoy']
}, {
  badge: 'TOMO 02',
  title: '🔍 El Detector de Mentiras',
  subtitle: 'Cómo leer micro-expresiones en tiempo real',
  description: 'La ciencia detrás de la mentira y cómo detectarla sin acusar. Fugas biológicas de culpa, patrones de voz y el protocolo de verificación en 4 pasos que usan los interrogadores profesionales.',
  bullets: ['Qué pasa en el cerebro cuando alguien miente', 'Las fugas biológicas de culpa (cuello, manos, pies)', 'Patrones de voz y discurso que delatan', 'Protocolo de verificación en 4 pasos', 'Los errores fatales al detectar mentiras']
}, {
  badge: 'TOMO 03',
  title: '💫 El Código del Deseo',
  subtitle: 'Señales de atracción, rechazo y manipulación',
  description: 'El semáforo gestual completo para saber si le gustás o solo es amable. Señales de manipulación en el amor, lectura de pareja y cómo reactivar la conexión no verbal.',
  bullets: ['12 señales femeninas y 12 masculinas de interés real', 'Semáforo gestual: Verde / Amarillo / Rojo', 'Señales de rechazo que nadie quiere ver', 'Manipulación emocional y sus gestos', 'Diagnóstico de pareja en 10 minutos']
}, {
  badge: 'TOMO 04',
  title: '🤫 El Interrogador Silencioso',
  subtitle: 'Técnicas para que otros confiesen sin preguntar',
  description: 'El poder del silencio estratégico. Cómo crear las condiciones para que la verdad salga sola. Técnicas de interrogación pasiva con protocolo maestro de 7 pasos.',
  bullets: ['El método del espejo verbal', 'Posturas de autoridad y presión sutil', 'Cómo leer respuestas en tiempo real', 'Aplicaciones: pareja, trabajo, hijos', 'Protocolo maestro en 7 pasos']
}, {
  badge: 'TOMO 05',
  title: '🛡️ El Escudo Mental',
  subtitle: 'Cómo protegerte de manipuladores y psicópatas',
  description: 'La anatomía del manipulador: sus técnicas y sus señales corporales. Cómo construir tu escudo no verbal y recuperarte del daño emocional con un protocolo claro.',
  bullets: ['Los 4 perfiles de manipulador más comunes', 'La tríada oscura y sus señales gestuales', 'Gaslighting, love bombing y silent treatment', 'Técnicas de protección no verbal', '25 banderas rojas que no podés ignorar']
}, {
  badge: 'TOMO 06',
  title: '👑 El Dominio Total',
  subtitle: 'Cómo proyectar autoridad, carisma y poder real',
  description: 'El cierre del sistema. Postura, mirada, voz y movimiento para proyectar presencia de élite. Dominio en negociaciones, conflictos, presentaciones y citas. Incluye plan de 30 días de integración.',
  bullets: ['La física del poder: espacio, altura y volumen', 'La mirada de liderazgo (no de dominación)', 'La voz como arma de autoridad', 'Carisma: la ciencia de la presencia (MIT)', 'Integración de los 6 tomos en 30 días']
}];
export function ProductContent() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="pt-6 pb-4 px-4 bg-deep-black" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-5" data-id="element-185">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-186">
            ¿Qué incluye el Pack Completo?
          </h2>
          <p className="text-base text-smoke/80" data-id="element-187">
            6 tomos PDF premium. +300 páginas de contenido práctico y aplicable.
          </p>
        </motion.div>

        <div className="space-y-2" data-id="element-188">
          {tomes.map((tomo, index) => <div key={index} className={`animate-fade-in-up stagger-${index + 1} bg-[#141414] border border-white/5 rounded-lg overflow-hidden transition-all duration-300 border-l-4 ${openIndex === index ? 'border-l-gold shadow-glow-gold/20' : 'border-l-gold/30 hover:border-l-gold/60'}`} data-id="element-189">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-3 flex items-center justify-between text-left focus:outline-none" data-id="element-190">
                <div className="flex flex-col md:flex-row md:items-center gap-1.5 md:gap-4" data-id="element-191">
                  <span className="text-[10px] font-bold tracking-widest text-gold bg-gold/10 px-2 py-0.5 rounded-full w-max" data-id="element-192">
                    {tomo.badge}
                  </span>
                  <div data-id="element-193">
                    <h3 className="font-heading text-base font-bold text-white" data-id="element-194">
                      {tomo.title}
                    </h3>
                    <p className="text-smoke/60 text-xs" data-id="element-195">{tomo.subtitle}</p>
                  </div>
                </div>
                <ChevronDownIcon className={`w-5 h-5 text-smoke/50 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180 text-gold' : ''}`} data-id="element-196" />
              </button>

              <AnimatePresence data-id="element-197">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-198">
                    <div className="px-4 pb-4 pt-1 border-t border-white/5 mt-1" data-id="element-199">
                      <p className="text-smoke/90 mb-3 text-sm leading-relaxed" data-id="element-200">
                        {tomo.description}
                      </p>
                      <ul className="space-y-1.5" data-id="element-201">
                        {tomo.bullets.map((bullet, bIndex) => <li key={bIndex} className="flex items-start gap-2 text-smoke/80 text-sm" data-id="element-202">
                            <CheckIcon className="w-4 h-4 text-electric-blue shrink-0 mt-0.5" data-id="element-203" />
                            <span data-id="element-204">{bullet}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}